import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const RelatedAgenciesData = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [agencyId, setAgencyId] = useState("");
  const agentData = useSelector((state) => state.principals.data);

  useEffect(() => {
    if (data?.length > 0) {
      setFilteredData(data);
    }
  }, [data, agencyId]);

  useEffect(() => {
    if (agencyId === "" && agencyId !== undefined) {
      setAgencyId(sessionStorage.getItem("agencyId"));
      setData(
        agentData.data && agentData.data.getPrincipalsByAgencyId
          ? agentData.data.getPrincipalsByAgencyId
          : []
      );
    }
  }, [agentData, agencyId]);

  const createSetFromFilteredDataAndIndex = (key, idKey) => {
    const uniqueData = filteredData.reduce((acc, row) => {
      if (
        !acc.find((item) => item.id === row[idKey] && item.value === row[key])
      ) {
        acc.push({ id: row[idKey], value: row[key] });
      }
      return acc.sort((a, b) => String(a.value).localeCompare(String(b.value)));
    }, []);

    return uniqueData;
  };

  return createSetFromFilteredDataAndIndex("principalName", "principalId");
};

export default RelatedAgenciesData;
